import { render, staticRenderFns } from "./vNavigation.vue?vue&type=template&id=27c4ee8c&scoped=true"
import script from "./vNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./vNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vNavigation.vue?vue&type=style&index=0&id=27c4ee8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4ee8c",
  null
  
)

export default component.exports